import { atom } from 'jotai';
import { getImNotifySetting } from '@/apis/im';
import type { DtoListImNotifySettingResp } from '@/apis/im';

export interface NotifySettingState {
  data?: DtoListImNotifySettingResp;
  loading: boolean;
  error?: unknown;
}

export const notifySettingAtom = atom<NotifySettingState>({ loading: false });

export const refreshNotifySettingAtom = atom(null, async (get, set) => {
  const currentState = get(notifySettingAtom);
  set(notifySettingAtom, { ...currentState, loading: true });
  try {
    const data = await getImNotifySetting();
    set(notifySettingAtom, { loading: false, data });
  } catch (error) {
    set(notifySettingAtom, { loading: false, error, data: currentState.data });
  }
});
